export const createConfirmUser = (body) => {
  return fetch('/api/v1/users/confirm', {
    method: 'POST',
    body: JSON.stringify(body),     
    headers: {'Content-Type': 'application/json', 'Accept': 'application/json' }
  })
  .then(res => res.json())
}